module.exports = __webpack_public_path__ + "img/sello2023.26f400c.png";


//////////////////
// WEBPACK FOOTER
// ./static/cyber/sello2023.png
// module id = Mzq1
// module chunks = 1